import React from 'react'
import {DropzoneDialog} from 'material-ui-dropzone'


 function useFileDropZone({handleFile, fileLimit = 1}) {

    const [open, setOpen] = React.useState(false)

    
    const handleDropzoneSave= React.useCallback(
        (f)=>{   
        handleFile(f)
        setOpen(false)
    },[handleFile, setOpen])


    function handleDropZoneClose(){ setOpen(false) }
    function handleDropZoneOpen() { setOpen(true) }

    const DropZone  = React.useCallback(
        () => (
            <DropzoneDialog 
            open={open}
            onSave={handleDropzoneSave} showPreviews={true}
            dropzoneText="Glisser déposer ou cliquer et selectionner"
            dialogTitle=""
            filesLimit={fileLimit}
            onClose={handleDropZoneClose} showFileNamesInPreview={true}
            showFileNames={true} />
        ),
        [open, handleDropzoneSave, fileLimit],
    )

    return{ DropZone, handleDropZoneOpen}
}



export default useFileDropZone